/* 🤖 this file was generated by svg-to-ts */
export const matIconExpand: {
  name: 'expand';
  data: string;
} = {
  name: 'expand',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 20h16v2H4zM4 2h16v2H4zm5.41 11.59L8 15l4 4 4-4-1.41-1.41L13 15.17V8.83l1.59 1.58L16 9l-4-4-4 4 1.41 1.41L11 8.83v6.34z"/></svg>`
};
